import React, { useEffect } from "react";
import "./index.css";
import aa from "../../assets/c1.png";
import ab from "../../assets/c2.png";
import ac from "../../assets/c3.png";
import ad from "../../assets/c5.png";
import company from "../../assets/company1.png";
import address from "../../assets/address.png";
// import MapContainer from "../Map/MapContainer";
import AMapLoader from '@amap/amap-jsapi-loader';
export default function Contact() {
  useEffect(() => {
    AMapLoader.load({
      "key": "bb8f90cbf6fc0135927c9a74b10fd3a9",   // 申请好的Web端开发者Key，首次调用 load 时必填
      "version": "2.0",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      "plugins": []  //插件列表
    }).then((AMap) => {
      let amap = new AMap.Map('mapContainer', { // mapcontainer为容器的id
        // zoom: 20,
        // viewMode: '3D',

        pitch: 50, //地图俯仰角度，有效范围 0 度- 83 度
        viewMode: '3D', //地图模式
        rotateEnable: true, //是否开启地图旋转交互 鼠标右键 + 鼠标画圈移动 或 键盘Ctrl + 鼠标左键画圈移动
        pitchEnable: true, //是否开启地图倾斜交互 鼠标右键 + 鼠标上下移动或键盘Ctrl + 鼠标左键上下移动
        zoom: 17, //初始化地图层级
        rotation: -15, //初始地图顺时针旋转的角度
        zooms: [2, 20], //地图显示的缩放级别范围
        center: ['120.204294', '30.188196'] //初始化地图中心点
      });
      // 标记
      let marker = new AMap.Marker({
        position: ['120.204294', '30.188196'] // 基点位置
      });
      // 地图添加标记
      console.log(marker._position[0], 'marker')
      if (marker._position[0] == NaN) {

      } else {
        amap.add(marker);
      }
    }).catch(e => {
      console.log(e);
    })
  });

  return (
    <div>
      <div className="contact">
        <h2>联系我们</h2>
        <div className="xian"></div>
        <div className="en">Contact Us</div>
        <div className="imga">
          <img src="https://bluetron-eco.oss-cn-hangzhou.aliyuncs.com/basic/static/owe/banner/about-img.jpg" alt="" />
          <div style={{ clear: "both" }}></div>
        </div>
        <div>
          <ul>
            <li>
              <div>
                <img src={aa} alt="" />
              </div>
              <span className="phone">公司座机</span>
              <span>0571-88352180</span>
            </li>
            <li>
              <div>
                <img src={ab} alt="" />
              </div>
              <span className="phone">邮件地址</span>
              <span>cnetwis@cnetwis.cn</span>
            </li>
            <li>
              <div>
                <img src={ac} alt="" />
              </div>
              <span className="phone">公司地址</span>
              <span>
                浙江省杭州市滨江区长河街道滨安路1180号1幢2号楼2层2001-2028室
              </span>
            </li>
            <li>
              <div>
                <img
                  src={ad}
                  alt=""
                  style={{ width: "50px", height: "50px" }}
                />
              </div>
              <span className="phone">办公时间</span>
              <span>周一至周五 9:00-17:30</span>
            </li>
          </ul>
        </div>
      </div>
      {/* <MapContainer></MapContainer> */}
      <div id="mapContainer" style={{ width: '90%', height: '500px', margin: 'auto' }}></div>
    </div>
  );
}

